import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { applyJob, fetchAppliedJobs } from "./AppliedJobsAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchAppliedJobsAsync = createAsyncThunk(
  "AppliedJobs/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchAppliedJobs();

      const resp = data?.response?.data;
      // console.log("data's response", data.response);
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const applyJobAsync = createAsyncThunk(
  "AppliedJobs/add",
  async ({appliedJob}) => {
    try {
      const data = await applyJob( appliedJob);
      // console.log("data in slice", data);
      return data;
    } catch (error) {
      console.log("errorL :", error);
      // return rejectWithValue(error.message);
    }
  }
);



const AppliedJobsSlice = createSlice({
  name: "AppliedJobs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppliedJobsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppliedJobsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        // console.log("DAta", action.payload)
        state.error = null;
      })
      .addCase(fetchAppliedJobsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(applyJobAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (Array.isArray(state.data)) {
          state.data?.push(action.payload);
        } else {
          state.data = [action.payload]; // Initialize as an array if it's not already
        }
      })
      .addCase(applyJobAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to apply job";
      })
  },
});

export const selectAppliedJobs = (state) => state.appliedJob.data;

export default AppliedJobsSlice.reducer;
